import { Checkbox, Col, Form, Input, Row, Select } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { LearnChannelSelect } from "components/forms/LearnChannelSelect";
import { NcCaptcha } from "components/forms/NcCaptcha";
import { YituDeclareCheckBox } from "components/forms/YituDeclareCheckBox";
import * as _ from "lodash";
import React from "react";
import { getDefaultPopupContainer } from "utils";
import { useCorporateDicts } from "../api";
import "./index.scss";

const FormItem = Form.Item;

interface IProps extends FormComponentProps {}

export const BecomePartnerForm: React.SFC<IProps> = React.memo(props => {
  const { form } = props;
  const getFD = form.getFieldDecorator;
  const {
    companyBizType,
    companyServicedIndustry,
    registeredAddress,
    learnAboutChannel
  } = useCorporateDicts();

  // 我们希望其他放在最后
  const fixedLearnAboutChannelItems = [
    ...learnAboutChannel.filter(item => item.entryKey !== "other"),
    ...learnAboutChannel.filter(item => item.entryKey === "other")
  ];
  const { Option } = Select;

  return (
    <Form className="BecomePartnerForm">
      <Row gutter={[16, 0]}>
        <Col span={24}>
          <FormItem label="公司名称" colon={false}>
            {getFD("companyName", {
              rules: [{ required: true, message: "请输入公司名称" }]
            })(<Input placeholder="请输入公司名称" />)}
          </FormItem>
        </Col>

        <Col span={24} md={12}>
          <FormItem label="公司所在地" colon={false}>
            {getFD("registeredAddress", {
              rules: [{ required: true, message: "请输入公司所在地" }]
            })(
              <Select
                placeholder="请输入公司所在地"
                getPopupContainer={getDefaultPopupContainer}
              >
                {_.map(registeredAddress, (address: any) => (
                  <Option value={address.entryKey} key={address.entryKey}>
                    {address.entryValue}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>

        <Col span={24} md={12}>
          <FormItem label="您的姓名" colon={false}>
            {getFD("name", {
              rules: [{ required: true, message: "请输入您的姓名" }]
            })(<Input placeholder="请输入您的姓名" />)}
          </FormItem>
        </Col>

        <Col span={24} md={12}>
          <FormItem label="手机号码" colon={false}>
            {getFD("telephoneNum", {
              rules: [
                {
                  required: true,
                  message: "请输入有效的手机号码",
                  pattern: /^1(3|4|5|6|7|8|9)\d{9}$/
                }
              ]
            })(
              <Input
                placeholder="请输入手机号码"
                className="BecomePartnerForm-text-input"
              />
            )}
          </FormItem>
        </Col>

        <Col span={24} md={12}>
          <FormItem label="邮箱地址" colon={false}>
            {getFD("email", {
              rules: [
                {
                  required: true,
                  message: "请输入邮箱地址"
                },
                {
                  message: "请输入有效的邮箱地址",
                  pattern: /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/
                }
              ]
            })(<Input placeholder="请输入邮箱地址" />)}
            <span className="BecomePartnerForm-memo">
              请确认该邮箱，依图后续会通过此邮箱与您联系
            </span>
          </FormItem>
        </Col>
      </Row>

      <FormItem label="您公司所从事的业务（可多选）" colon={false}>
        {getFD("companyBizTypeList", {
          rules: [
            {
              required: true,
              message: "请选择您公司所从事的业务（可多选）"
            }
          ]
        })(
          <Checkbox.Group>
            <Row gutter={[16, 8]}>
              {_.map(companyBizType, type => {
                const { entryKey, entryValue } = type;
                return (
                  <Col span={24} md={12} key={entryKey}>
                    <Checkbox value={entryKey}>{entryValue}</Checkbox>
                  </Col>
                );
              })}
            </Row>
          </Checkbox.Group>
        )}
      </FormItem>

      <FormItem label="您公司服务过的行业（可多选）" colon={false}>
        {getFD("companyServicedIndustryList", {
          rules: [
            {
              required: true,
              message: "请选择您公司服务过的行业（可多选）"
            }
          ]
        })(
          <Checkbox.Group>
            <Row gutter={[16, 8]}>
              {_.map(companyServicedIndustry, type => {
                const { entryKey, entryValue } = type;
                return (
                  <Col key={entryKey} span={12}>
                    <Checkbox value={entryKey}>{entryValue}</Checkbox>
                  </Col>
                );
              })}
            </Row>
          </Checkbox.Group>
        )}
      </FormItem>

      <FormItem label="您是如何得知依图的？(可多选)" colon={false}>
        {getFD("learnAboutChannel", {
          rules: [
            {
              required: true,
              message: "您是如何得知依图的？(可多选)"
            }
          ]
        })(
          <LearnChannelSelect form={form} dicts={fixedLearnAboutChannelItems} />
        )}
      </FormItem>

      {/** 声明 */}
      {getFD("legalAgreement", {
        rules: [{ required: true, message: "请阅读声明" }]
      })(<YituDeclareCheckBox />)}

      {/** 人机校验 */}
      <Form.Item label={null}>
        {getFD("ncParams", {
          rules: [{ required: true, message: "请完成人机验证" }]
        })(<NcCaptcha />)}
      </Form.Item>
    </Form>
  );
});
